import UmpIcon from '../components/UmpIcon';
import { connect } from 'react-redux';
import {
  HStack,
  Tooltip,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from '@chakra-ui/react';

const UmpSupplyInput = ({ onUmpSupplyChange, umpSupply, boxInfo }) => {
  const handleUmpSupplyChange = valueString => {
    const newSupply = parseFloat(valueString);
    if (!isNaN(newSupply)) {
      onUmpSupplyChange(newSupply); // Dispatch Redux action
    }
  };

  const getHPUmp = () => {
    const umpiresObj = boxInfo.find(item => item.label === 'Umpires');

    // Check if umpiresObj is found and extract the 'value' property
    if (umpiresObj) {
      const umpiresArray = umpiresObj.value.split('. ');
      const hpUmpire = umpiresArray.find(umpire => umpire.startsWith('HP'));
      return hpUmpire ? hpUmpire.split(': ')[1] : null;
    }
    return null;
  };

  return (
    <Tooltip hasArrow label={getHPUmp({ boxInfo })} fontSize="md">
      <HStack>
        <UmpIcon boxSize={9} />
        <NumberInput
          id="UmpSupply"
          size="md"
          maxW={20}
          min={0}
          defaultValue={0}
          value={umpSupply} // Get value from Redux store
          onChange={handleUmpSupplyChange}
        >
          <NumberInputField borderRadius="none" borderColor="card.border" borderWidth="1px" />
          <NumberInputStepper>
            <NumberIncrementStepper borderRadius="none" />
            <NumberDecrementStepper borderRadius="none" />
          </NumberInputStepper>
        </NumberInput>
      </HStack>
    </Tooltip>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    onUmpSupplyChange: newUmpSupply =>
      dispatch({ type: 'UPDATE_UMP_SUPPLY', payload: newUmpSupply }),
  };
};

const mapStateToProps = state => {
  return {
    umpSupply: state.umpSupply,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UmpSupplyInput);
